import styled from "styled-components";

import { Info24px } from "@similarweb/icons";
import { colorsPalettes, setElevation, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

const { carbon, blue } = colorsPalettes;

export const Header = styled(Stack)<{ $isActive: boolean }>`
    ${setFontVariant("subTitle3Alt", carbon[400])};
    justify-content: center;
    gap: 8px;
    height: 24px;
`;

export const TitleText = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
`;

export const Container = styled(Flex)`
    position: relative;
    padding: 0;
    background: ${carbon[0]};
    border-radius: 6px;
    width: 50%;
    height: 209px;
    overflow: hidden;

    &:not([data-state="loading"]):hover {
        cursor: pointer;
        ${setElevation("Z1_hover")};

        ${Header} {
            color: ${blue[400]};
            text-decoration: underline;
        }
    }
`;

export const EmptyStateOverlayWrapper = styled(Flex)`
    position: absolute;
    inset: 0;
    z-index: 10;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(8px);
    cursor: pointer;
`;

export const MainColumn = styled(Stack)<{ $isRightAside: boolean }>`
    flex: 1;
    gap: 8px;
    min-width: 0;
    padding: 16px;

    ${({ $isRightAside }) => ($isRightAside ? "padding-right:8px;" : null)}
`;

export const Body = styled(Flex)`
    flex: 1;
    overflow: hidden;
`;

export const RightAside = styled(Flex)`
    flex: 0 0 50%;
    align-self: stretch;
    min-width: 0;
    padding: 8px;
`;

export const HeaderFlex = styled(Flex)`
    min-width: 0;
    overflow: hidden;
`;

export const InfoIcon = styled(Info24px)`
    transform: scale(1.5);
    flex-shrink: 0;
`;
